import { render } from "./CertificatesList.vue?vue&type=template&id=26267e1c&scoped=true"
import script from "./CertificatesList.vue?vue&type=script&lang=js"
export * from "./CertificatesList.vue?vue&type=script&lang=js"

import "./CertificatesList.vue?vue&type=style&index=0&id=26267e1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26267e1c"]])

export default __exports__